"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _antd = require("antd");

var _react = _interopRequireWildcard(require("react"));

var _config = _interopRequireDefault(require("../../../../config.json"));

var _axios = _interopRequireDefault(require("axios"));

var _moment = _interopRequireDefault(require("moment"));

var _errorPage = _interopRequireDefault(require("../../../error-views/errorPage"));

var _RmName = _interopRequireDefault(require("../../../../RmName.json"));

// import { useHistory } from 'react-router';
var MonthPicker = _antd.DatePicker.MonthPicker;
var Option = _antd.Select.Option;
var date = new Date();
var year = date.getFullYear();
var month = ("0" + (date.getMonth() + 1)).slice(-2);
var todayDate = "".concat(year, "-").concat(month);

var RMrating = function RMrating() {
  var cl = localStorage.getItem("CL");
  var token = localStorage.getItem("token");

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      apiError = _useState2[0],
      setapiError = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1]; // const history = useHistory();


  var _Form$useForm = _antd.Form.useForm(),
      _Form$useForm2 = (0, _slicedToArray2.default)(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      list = _useState6[0],
      setList = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      showForm = _useState8[0],
      setShowForm = _useState8[1];

  var _useState9 = (0, _react.useState)(todayDate),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      month = _useState10[0],
      setMonth = _useState10[1];

  var initialFormValues = {
    'rmCode': '',
    'rmName': '',
    'activeStudent': '',
    'dropoutStudent': '',
    'responseRate': '',
    'formsFilledNextDay': 'Choose option',
    'lateInTraining': 'Choose option',
    'auditMarks': '',
    'whatRMdoes': ''
  };
  var nextDayOption = ["6+ बार देर से भरा", "3-5 बार देर से भरा", "1-2 बार देर से भरा", "कभी देर नहीं करते"];
  var lateTraingOption = ['3 से ज्यादा ट्रेनिंग में लेट', 'दो ट्रेनिंग में लेट', 'एक ट्रेनिंग में लेट', 'कभी लेट नहीं किया'];
  var rmWorkOption = ['पेरेंट्स को कॉल नहीं करती खुद से जब तक कोई ना बताए CR उनकी समस्या को नहीं सुनती क्यूंकि CR का फोकस उसका काम होना चाहिए।', 'पहले CL को बोलती है कि CL ही पैरेंट से बात करें,और पेरेंट्स की मदद करने की कोशिश करती है।', 'CR और CL साथ बात करते है,और पेरेंट्स की मदद करने की कोशिश करती है।', 'खुद से बात करती और पेरेंट की समस्या का समाधान करती है।']; // useEffect(async () => {
  //   let url1 = config.rmDetails + cl
  //   await axios.get(url1, { headers: { 'Authorization': token } })
  //     .then(resp => {
  //       if (resp.data.status === "error") setapiError(resp.data);
  //       else{
  //         let arr = resp.data.filter(item => item.Status === "Active");
  //         setList(arr);
  //         setLoading(false)
  //       }
  //     }, error => {
  //       let obj={"status":"error","message":"Network Error"};
  // 			if(error.response) setapiError(error.response);
  // 		   else setapiError(obj);
  //     });
  // }, []);

  (0, _react.useEffect)(function () {
    function fetchData() {
      return _fetchData.apply(this, arguments);
    }

    function _fetchData() {
      _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var url1;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url1 = _config.default.rmDetails + cl;
                _context.next = 3;
                return _axios.default.get(url1, {
                  headers: {
                    'Authorization': token
                  }
                }).then(function (resp) {
                  if (resp.data.status === "error") setapiError(resp.data);else {
                    var arr = resp.data.filter(function (item) {
                      return item.Status === "Active";
                    });
                    setList(arr);
                    setLoading(false);
                  }
                }, function (error) {
                  var obj = {
                    "status": "error",
                    "message": "Network Error"
                  };
                  if (error.response) setapiError(error.response);else setapiError(obj);
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchData.apply(this, arguments);
    }

    fetchData(); // eslint-disable-next-line 
  }, []);

  var SelectRM = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(value) {
      var data;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              data = list.find(function (obj) {
                return obj.RM_code === value;
              });
              _context2.next = 3;
              return getData(data);

            case 3:
              form.setFieldsValue(initialFormValues);
              setShowForm(true);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function SelectRM(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  function onChange(date, dateString) {
    setMonth(dateString);
  }

  var onFinish = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(values) {
      var dropOut, enroll, respRate, audit, fillNextDay, lateTraining, rmDoes, value, _value, _value2, _value3, rating, obj, url;

      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dropOut = 0, enroll = 0, respRate = 0, audit = 0, fillNextDay = 0, lateTraining = 0, rmDoes = 0;

              if (values.dropoutStudent) {
                value = values.dropoutStudent;

                if (value >= 6) {
                  dropOut = 1 * 0.1;
                } else if (value >= 3 && value <= 5) {
                  dropOut = 2 * 0.1;
                } else if (value >= 1 && value <= 2) {
                  dropOut = 3 * 0.1;
                } else {
                  dropOut = 4 * 0.1;
                }
              }

              if (values.activeStudent) {
                _value = values.activeStudent;

                if (_value >= 0 && _value <= 15) {
                  enroll = 1 * 0.1;
                } else if (_value >= 16 && _value <= 29) {
                  enroll = 2 * 0.1;
                } else if (_value >= 29 && _value <= 39) {
                  enroll = 3 * 0.1;
                } else {
                  enroll = 4 * 0.1;
                }
              }

              if (values.responseRate) {
                _value2 = values.responseRate;

                if (_value2 >= 0 && _value2 <= 74) {
                  respRate = 1 * 0.3;
                } else if (_value2 >= 74 && _value2 <= 89) {
                  respRate = 2 * 0.3;
                } else if (_value2 >= 90 && _value2 <= 99) {
                  respRate = 3 * 0.3;
                } else {
                  respRate = 4 * 0.3;
                }
              }

              if (values.auditMarks) {
                _value3 = values.auditMarks;

                if (_value3 >= 0 && _value3 < 60) {
                  audit = 1 * 0.3;
                } else if (_value3 >= 60 && _value3 < 80) {
                  audit = 2 * 0.3;
                } else if (_value3 >= 80 && _value3 < 90) {
                  audit = 3 * 0.3;
                } else {
                  audit = 4 * 0.3;
                }
              }

              if (values.formsFilledNextDay) {
                fillNextDay = (nextDayOption.indexOf(values.formsFilledNextDay) + 1) * 0.05;
              }

              if (values.lateInTraining) {
                lateTraining = (lateTraingOption.indexOf(values.lateInTraining) + 1) * 0.05;
              }

              if (values.whatRMdoes) {
                rmDoes = (rmWorkOption.indexOf(values.whatRMdoes) + 1) * 0.1;
              }

              rating = enroll + dropOut + respRate + audit + fillNextDay + lateTraining + rmDoes;
              obj = {
                month: month,
                RMcode: values.rmCode,
                activeParents: values.activeStudent,
                dropoutParents: values.dropoutStudent,
                responseRate: values.responseRate,
                formsFilledNextDay: values.formsFilledNextDay,
                lateInTraining: values.lateInTraining,
                auditMarks: values.auditMarks,
                whatRMdoes: values.whatRMdoes,
                rating: rating
              };
              url = _config.default.RMRatingForm + cl;

              _axios.default.post(url, obj, {
                headers: {
                  'Authorization': token
                }
              }).then(function (resp) {
                if (resp.data.status === "error") setapiError(resp.data);
                alert("Rating of " + values.rmCode + " submitted Successfully");
                setShowForm(false);
              }, function (error) {
                setapiError(error.response);
              });

              initialFormValues.rmCode = "";

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function onFinish(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  function getData(_x3) {
    return _getData.apply(this, arguments);
  }

  function _getData() {
    _getData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(details) {
      var url1, initialFormValue;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              url1 = _config.default.getDataForRating + cl + "&RMCode=" + details.RM_code;
              initialFormValue = {};
              _context4.next = 4;
              return _axios.default.get(url1, {
                headers: {
                  'Authorization': token
                }
              }).then(function (resp) {
                if (resp.data.status === "error") setapiError(resp.data);else {
                  var objDetails = resp.data;
                  initialFormValue = {
                    'rmCode': details.RM_code,
                    'rmName': details.RM_Name,
                    'activeStudent': objDetails.enrolledStudent,
                    'dropoutStudent': objDetails.dropedStudent,
                    'responseRate': objDetails.rating,
                    'formsFilledNextDay': objDetails.formsFilledNextDay,
                    'lateInTraining': objDetails.lateInTraining,
                    'auditMarks': objDetails.audtScore,
                    'whatRMdoes': ''
                  };
                  initialFormValues = initialFormValue;
                }
              }, function (error) {
                var obj = {
                  "status": "error",
                  "message": "Network Error"
                };
                if (error.response) setapiError(error.response);else setapiError(obj);
              });

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _getData.apply(this, arguments);
  }

  return apiError ? /*#__PURE__*/_react.default.createElement(_errorPage.default, {
    details: apiError
  }) : loading ? /*#__PURE__*/_react.default.createElement(_antd.Spin, {
    tip: "Loading..."
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: 16
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 24,
    xl: 24,
    xxl: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Filter"
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [4, 4]
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    className: "mt-2",
    xs: 24,
    sm: 24,
    md: 24,
    lg: 12,
    xl: 12,
    xxl: 12
  }, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement("b", null, "Choose A ".concat(_RmName.default.name), " :")), "\xA0", /*#__PURE__*/_react.default.createElement(_antd.Select, {
    showSearch: true,
    style: {
      width: 150
    },
    placeholder: "Search or Select CR Code",
    optionFilterProp: "children",
    filterOption: function filterOption(input, option) {
      return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    filterSort: function filterSort(optionA, optionB) {
      return optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase());
    },
    onChange: SelectRM
  }, list.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(Option, {
      key: item.S_no,
      value: item.RM_code
    }, item.RM_code);
  }))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    className: "mt-2",
    xs: 24,
    sm: 24,
    md: 24,
    lg: 12,
    xl: 12,
    xxl: 12
  }, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement("b", null, "Choose A Month :")), "\xA0", /*#__PURE__*/_react.default.createElement(MonthPicker, {
    defaultValue: (0, _moment.default)(month, 'YYYY-MM'),
    onChange: onChange,
    placeholder: "Select month"
  })))))), initialFormValues.rmCode || showForm ? /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Fill CR Rating"
  }, /*#__PURE__*/_react.default.createElement(_antd.Form, {
    name: "basic",
    size: "small",
    wrapperCol: 4,
    form: form,
    onFinish: onFinish,
    initialValues: initialFormValues
  }, /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "rmName",
    label: _RmName.default.RMName,
    rules: [{
      required: true,
      message: 'The field is required'
    }]
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    autoComplete: "off",
    value: "rmName",
    style: {
      width: 280
    },
    disabled: true
  })), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "rmCode",
    label: _RmName.default.nameCode,
    rules: [{
      required: true,
      message: 'The field is required'
    }]
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    autoComplete: "off",
    value: "rmCode",
    style: {
      width: 280
    },
    disabled: true
  })), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "activeStudent",
    label: "Active Students",
    rules: [{
      required: true,
      message: 'The field is required'
    }]
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    autoComplete: "off",
    value: "activeStudent",
    style: {
      width: 280
    }
  })), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "dropoutStudent",
    label: "Drop Out Students",
    rules: [{
      required: true,
      message: 'The field is required'
    }]
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    autoComplete: "off",
    value: "dropoutStudent",
    style: {
      width: 280
    }
  })), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "responseRate",
    label: "Response Rate",
    rules: [{
      required: true,
      message: 'The field is required'
    }]
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    autoComplete: "off",
    value: "responseRate",
    style: {
      width: 280
    }
  })), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "auditMarks",
    label: /*#__PURE__*/_react.default.createElement("span", {
      style: {
        fontWe: "bolder"
      }
    }, "\u0911\u0921\u093F\u091F \u0915\u0947 \u092E\u093E\u0930\u094D\u0915\u094D\u0938"),
    rules: [{
      required: true,
      message: 'The field is required'
    }]
  }, /*#__PURE__*/_react.default.createElement(_antd.Input, {
    autoComplete: "off",
    value: "auditMarks",
    style: {
      width: 280
    }
  })), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "lateInTraining",
    label: "\u091F\u094D\u0930\u0947\u0928\u093F\u0902\u0917 \u0905\u091F\u0947\u0902\u0921 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0938\u092E\u092F \u092E\u0947\u0902",
    rules: [{
      required: true,
      message: 'The field is required'
    }]
  }, /*#__PURE__*/_react.default.createElement(_antd.Select, {
    placeholder: initialFormValues.lateInTraining
  }, lateTraingOption.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(Option, {
      value: item,
      key: index
    }, item);
  }))), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "formsFilledNextDay",
    label: "35 \u092B\u0949\u0930\u094D\u092E\u094D\u0938 \u0938\u0947 \u095B\u094D\u092F\u093E\u0926\u093E \u092B\u0949\u0930\u094D\u092E \u0905\u0917\u0932\u0947 \u0926\u093F\u0928 \u092D\u0930\u0947\u0902",
    rules: [{
      required: true,
      message: 'The field is required'
    }]
  }, /*#__PURE__*/_react.default.createElement(_antd.Select, {
    placeholder: initialFormValues.formsFilledNextDay
  }, nextDayOption.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(Option, {
      value: item,
      key: index
    }, item);
  }))), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    name: "whatRMdoes",
    label: "\u0905\u0917\u0930 ".concat(_RmName.default.name, " \u0915\u093E \u0930\u0947\u0938\u094D\u092A\u094B\u0902\u0938 \u0930\u0947\u091F \u0915\u092E \u0939\u0948 \u092F\u093E \u092A\u0948\u0930\u0947\u0902\u091F \u0915\u094B \u0914\u0930 \u0915\u094B\u0908 \u0914\u0930 \u0938\u092E\u0938\u094D\u092F\u093E \u0939\u094B \u0924\u094B?"),
    rules: [{
      required: true,
      message: 'The field is required'
    }]
  }, /*#__PURE__*/_react.default.createElement(_antd.Radio.Group, {
    span: true
  }, rmWorkOption.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "  ", /*#__PURE__*/_react.default.createElement(_antd.Radio, {
      value: item,
      style: {
        marginTop: 8
      }
    }, item), " ", /*#__PURE__*/_react.default.createElement("br", null));
  }))), /*#__PURE__*/_react.default.createElement(_antd.Form.Item, {
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    type: "primary",
    htmlType: "submit"
  }, "Submit")))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Spin, {
    tip: "Loading..."
  }, /*#__PURE__*/_react.default.createElement(_antd.Alert, {
    message: "Select ".concat(_RmName.default.nameCode),
    description: "Details loading will take some time",
    type: "info"
  }))));
};

var _default = RMrating;
exports.default = _default;